import React from "react";

/**
 * Contract Holder Program Performance "Customer Satisfaction" More Info Component
 * @returns {Element}
 * @constructor
 */
export default function CustomerSatisfaction() {
  return (<tr className="extra-info">
    <td colSpan={6}>
      <div>
        <h6 className="bold">Customer Satisfaction</h6>
        <p>The Customer Satisfaction rating is based on the quality of products and services, responsiveness, and
          interaction with customers and problem resolution.</p>
        <ul className="performance-desc-range">
          <li className="excellent">Excellent - 0-1</li>
          <li className="very-good">Very Good - 2-3</li>
          <li className="good">Good - 4-5</li>
          <li className="fair">Fair - 6-7</li>
          <li className="poor">Poor - &#62; 7</li>
        </ul>

        <ul>
          <li><strong>Excellent</strong> = 0-1 reports of quality issues or concerns and all resolved to customer
            satisfaction with little or no delay
          </li>
          <li><strong>Very Good</strong> = 2-3 reports of minor issues; all are resolved to customer satisfaction with
            little or no delay
          </li>
          <li><strong>Good</strong> = 4-5 reports of issues not all fully resolved and/or a continuing pattern of
            delayed response to a customer
          </li>
          <li><strong>Fair</strong> = 6-7 reports of issues that are not fully resolved and/or a continuing pattern of
            delayed response to a customer
          </li>
          <li><strong>Poor</strong> = 7+ reports of issues that are not fully resolved and/or a continuing pattern of
            delayed response to a customer
          </li>
          <li><strong>Neutral</strong> = Contract Holder has not received any orders or performed any work on the SEWP
            contracts to date
          </li>
        </ul>
      </div>
    </td>
  </tr>);
}